import { cropOrientationValues } from 'pages/Batch/configs';

import type { IBatchState } from 'types';

export const initCropTemplateValue = {
  id: 'freeform',
  title: 'FreeForm',
};

const initialState: IBatchState = {
  eraserItem: null,
  activeCustomBg: null,
  activeColor: null,
  objectPosition: null,
  bgToolRatio: null,
  cropAlign: null,
  cropTemplate: initCropTemplateValue,
  cropOrientation: cropOrientationValues[0],
  cropAttrs: [],
  cropRotate: 0,
  cropFlip: { x: 1, y: 1 },
  enhanceMapping: {},
  userWatermarks: [],
  backgroundCustomImages: [],
  enhanceBeforeAfter: null,
  latestAppliedTool: null,
  hasUsedSubscriptionTool: false,
  isToolApplying: false,
  generatedBackgrounds: [],
  previewCollection: {},
  activePreviewItem: null,
  suggestedBackgrounds: [],
  creditsData: {
    areCreditsFetched: false,
  },
  toolPrice: 0,
  wfxSelectedEffect: null,
  wfxActiveTab: 'effects',
  wfxSelectedOverlay: null,
  wfxShowSettings: false,
  wfxParamValues: {},
  wfxProcessAttrs: {
    effect: null,
    editorLibCategoryId: null,
    params: {},
    overlayResourceUrl: null,
    overlayBlendMode: 'normal',
    overlayIntensity: 100,
  },
  adjustProcessAttrs: {
    params: {},
  },
  lastAIBGPrompt: null,
  enhanceSelectedSmartAdjustment: null,
  enhanceSelectedBackgroundBlur: null,
  enhanceSmartAdjustmentIntensity: 35,
  enhanceBackgroundBlurIntensity: 60,
  enhanceActiveSection: null,
  enhanceActiveSubtool: null,
  enhanceItemIntensities: {},
  foregroundTransforms: {},
  foregroundContentBboxes: {},
};

export default initialState;
